import React from "react";
import Router from "./shared/Router";

function App() {
  return <Router />;
}

export default App;
